import React      from 'react';
import classNames from 'classnames';

function renderGridBlock(data, index, renderStaticSection) {
  const {
          BACKGROUND_COLOR,
          COLUMNS_COUNT: cols = 3,
          CONTENT             = [],
          LABEL,
        } = data;

  return (
    <section key={index} style={{ backgroundColor: BACKGROUND_COLOR }}>
      <div className={classNames('container', 'grid')}>
        {typeof LABEL === 'string' && LABEL.length > 0 && (
          <h2>{LABEL}</h2>
        )}
        {CONTENT.map((col, c) => (
          <div key={c} className={`col col-${cols}`}>
            {(col || []).map((block, b) => renderStaticSection(block, b))}
          </div>
        ))}
      </div>
    </section>
  );
}

export default renderGridBlock;